var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetryNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35131 1.25H6.33569e-05V0H4.37506L5.00006 0.625V5H3.75006V2.5C2.62971 3.34061 1.8242 4.53317 1.46274 5.88638C1.10129 7.23958 1.20486 8.67497 1.75682 9.96227C2.30879 11.2496 3.27716 12.3141 4.50658 12.9852C5.736 13.6563 7.15519 13.8949 8.53648 13.6629C9.91777 13.4309 11.1811 12.7416 12.1237 11.7056C13.0664 10.6696 13.6337 9.34707 13.7348 7.95008C13.8358 6.55308 13.4646 5.16264 12.6809 4.00183C11.8971 2.84102 10.7461 1.97713 9.41256 1.54875L9.79006 0.35625C11.4083 0.875159 12.8024 1.92828 13.7439 3.3431C14.6854 4.75791 15.1184 6.45053 14.9722 8.14366C14.8259 9.83679 14.1089 11.43 12.9387 12.6624C11.7685 13.8948 10.2145 14.6932 8.53117 14.9268C6.84787 15.1605 5.13513 14.8155 3.67351 13.9485C2.2119 13.0814 1.08808 11.7437 0.486175 10.1544C-0.115734 8.56516 -0.16005 6.81858 0.360487 5.20082C0.881025 3.58307 1.93555 2.19006 3.35131 1.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetryNotes);
export default __webpack_public_path__ + "static/media/retryNotes.236c036875ac2638fd9145a7f41adf7e.svg";
export { ForwardRef as ReactComponent };